import { render } from "./Dismantling.vue?vue&type=template&id=331dc618&scoped=true&ts=true&lang=pug"
import script from "./Dismantling.vue?vue&type=script&lang=ts"
export * from "./Dismantling.vue?vue&type=script&lang=ts"

import "./Dismantling.vue?vue&type=style&index=0&id=331dc618&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331dc618"]])

export default __exports__